import Helper from '@/Helper'
import lodash from 'lodash'
export default {
  getListGroupChecklistItem (state) {
    var data = []
    state.group_checklist_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (element.is_reject) {
        var tamp = lodash.findIndex(data, {id: element.parent_id})
        while (tamp !== -1) {
          data[tamp].is_reject = 1
          tamp = lodash.findIndex(data, {id: data[tamp].parent_id})
          // if (tamp !== -1) {
          //   data[tamp].is_reject = 1
          // }
        }
      }
    })
    return state.group_checklist_items
  }
}



// WEBPACK FOOTER //
// ./src/store/module/group-checklist-item/getters.js